
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","stroke":"#141B34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3.667l-.413 6.683c-.106 1.707-.159 2.561-.586 3.175-.212.304-.485.56-.8.752-.64.39-1.495.39-3.206.39-1.713 0-2.57 0-3.209-.39a2.668 2.668 0 01-.8-.754c-.428-.615-.48-1.47-.583-3.18L2 3.667M1 3.667h12m-3.296 0l-.455-.94c-.303-.623-.454-.935-.715-1.13a1.333 1.333 0 00-.183-.114c-.288-.15-.635-.15-1.328-.15-.71 0-1.066 0-1.36.156a1.333 1.333 0 00-.185.12c-.264.202-.41.525-.706 1.172l-.403.886M5.333 11V7M8.667 11V7","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    